.articleGroup {
  display: flex;
  flex-direction: column;
  gap: 0.5em;
}
